//

// import URLstateContext from "../../../provider/CommonContext";
// import React, { useEffect, useState, useContext, useMemo } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import { tabsClasses } from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import { useNavigate } from "react-router-dom";
// import Box from "@mui/material/Box";
// import TabPanel from "@mui/lab/TabPanel";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import MarketOutlookComponent from "../../CommunicationHub/MarketOutlook";
// // import "../videogallery.css";
// import BBB from "./BBB";
// import OtherVideos from "./OtherVideos";

// export default function VideoGallery() {
//   const [value, setValue] = useState(1);
//   const { BaseURL, fontSize } = useContext(URLstateContext);

//   const arrayOfTabsObj = [
//     { name: "Market Outlook", id: 1 },
//     // { name: "Baatein Bazaar & Beyond", id: 2 },
//     { name: "Other Videos", id: 3 },
//   ];

  
// //   const arrayOfTabsObj = [
// //   { name: "Market Outlook", path: "marketoutlook", id: 1 },
// //   // { name: "Baatein Bazaar & Beyond", path: "baateinbazaar-beyond", id: 2 },
// //   { name: "Other Videos", path: "othervideos", id: 3 },
// // ];

//   const navigate = useNavigate();

//   // const handleChange = (event, newValue) => {
//   //   setValue(newValue);
//   //   const selectedTab = arrayOfTabsObj.find((tab) => tab.id === newValue);
//   //   navigate(`/Insights/VideoGallery/${selectedTab.name.replace(/\s+/g, "")}`);
//   // };

//   // useEffect(() => {
//   //   var para = window.location.pathname.toLocaleLowerCase().split("/")[3];
//   //   if (para === "Market Outlook") setValue(1);
//   //   if (para === "Baatein Bazaar & Beyond") setValue(2);
//   //   if (para === "Other Videos") setValue(3);
//   // }, []);

//     useEffect(() => {
//     var para = window.location.pathname.toLocaleLowerCase().split("/")[3];
//     if (para === "Market Outlook") setValue(1);
//     // if (para === "Baatein Bazaar & Beyond") setValue(2);
//     if (para === "Other Videos") setValue(3);
//   }, []);
  
// // useEffect(() => {
// //   const para = window.location.pathname.split("/")[3]?.toLowerCase();
// //   const match = arrayOfTabsObj.find(tab => tab.path === para);
// //   if (match) setValue(match.id);
// // }, []);

// const handleChange = (event, newValue) => {
//     setValue(newValue);
//     const selectedTab = arrayOfTabsObj.find((tab) => tab.id === newValue);
//     navigate(`/Insights/VideoGallery/${selectedTab.name.replace(/\s+/g, "")}`);
//   };
// // const handleChange = (event, newValue) => {
// //   setValue(newValue);
// //   const selectedTab = arrayOfTabsObj.find(tab => tab.id === newValue);
// //   navigate(`/Insights/VideoGallery/${selectedTab.path}`);
// // };


//   return (
//     <>
//       <section
//         className="Nav-detail about-detail reachout Media-center padding-top"
//         style={{ fontSize: `${fontSize}px` }}
//       >
//         <Box>
//           <TabContext value={value}>
//             <Container className="tabs-nav">
//               <Row>
//                 <Col sm={12}>
//                   <Box sx={{ width: "100%" }}>
//                     <TabList
//                       onChange={handleChange}
//                       variant="scrollable"
//                       sx={{
//                         [`& .${tabsClasses.scrollButtons}`]: {
//                           "&.Mui-disabled": { opacity: 0.3 },
//                         },
//                       }}
//                       className="press-tabs"
//                       style={{ width: "300px" }}
//                       scrollButtons="auto"
//                     >
//                       {arrayOfTabsObj.map((item) => (
//                         <Tab
//                           className={item.id == 3 ? "width185" : "width125"}
//                           style={{ padding: "12px" }}
//                           label={item.name}
//                           value={item.id}
//                         ></Tab>
//                       ))}
//                     </TabList>
//                   </Box>
//                 </Col>
//               </Row>
//             </Container>
//             <TabPanel value={1}>
//               <section className="press-release-sc">
//                 <Container>
//                   <Row>
//                     <Col sm={12} className="padding-left-0">
//                       <MarketOutlookComponent />
//                     </Col>
//                   </Row>
//                 </Container>
//               </section>
//             </TabPanel>
//             <TabPanel value={2}>
//               <section className="blog-sc global-blog-sc">
//                 <Container>
//                   <Row>
//                     <Container>
//                       <Col sm={12}>
//                         <BBB />
//                       </Col>
//                     </Container>
//                   </Row>
//                 </Container>
//               </section>
//             </TabPanel>
//             <TabPanel value={3}>
//               <section className="blog-sc global-blog-sc">
//                 <Container>
//                   <Row>
//                     <Container>
//                       <Col sm={12}>
//                         <OtherVideos/>
//                       </Col>
//                     </Container>
//                   </Row>
//                 </Container>
//               </section>
//             </TabPanel>
//           </TabContext>
//         </Box>
//       </section>
//     </>
//   );
// }


//

import URLstateContext from "../../../provider/CommonContext";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import MarketOutlookComponent from "../../CommunicationHub/MarketOutlook";
// import "../videogallery.css";
import BBB from "./BBB";
import OtherVideos from "./OtherVideos";

export default function VideoGallery() {
  const [value, setValue] = useState(1);
  const { BaseURL, fontSize } = useContext(URLstateContext);

  // const arrayOfTabsObj = [
  //   { name: "Market Outlook", id: 1 },
  //   // { name: "Baatein Bazaar & Beyond", id: 2 },
  //   { name: "Other Videos", id: 3 },
  // ];

   const arrayOfTabsObj = [
  { name: "Market Outlook", path: "marketoutlook", id: 1 },
  // { name: "Baatein Bazaar & Beyond", path: "baateinbazaar-beyond", id: 2 },
  { name: "NFO & OTHER VIDEOS", path: "othervideos", id: 3 },
];

  const navigate = useNavigate();


useEffect(() => {
  const para = window.location.pathname.split("/")[3]?.toLowerCase();
  const match = arrayOfTabsObj.find(tab => tab.path === para);
  if (match) setValue(match.id);
}, []);

const handleChange = (event, newValue) => {
  setValue(newValue);
  const selectedTab = arrayOfTabsObj.find(tab => tab.id === newValue);
  navigate(`/Insights/VideoGallery/${selectedTab.path}`);
};

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  //   const selectedTab = arrayOfTabsObj.find((tab) => tab.id === newValue);
  //   navigate(`/Insights/VideoGallery/${selectedTab.name.replace(/\s+/g, "")}`);
  // };

  // useEffect(() => {
  //   var para = window.location.pathname.toLocaleLowerCase().split("/")[3];
  //   if (para === "Market Outlook") setValue(1);
  //   // if (para === "Baatein Bazaar & Beyond") setValue(2);
  //   if (para === "Other Videos") setValue(3);
  // }, []);

  return (
    <>
      <section
        className=""
        style={{ fontSize: `${fontSize}px`, padding: 0 }}
      >
        <Box padding={0}>
          <TabContext value={value}>
            <Container className="tabs-nav">
              <Row>
                <Col>
                  <Box>
                    <TabList
                      onChange={handleChange}
                      variant="scrollable"
                      sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                      }}
                      className="press-tabs"
                      style={{ width: "300px" }}
                      scrollButtons="auto"
                    >
                      {arrayOfTabsObj.map((item) => (
                        <Tab
                          className={item.id == 3 ? "width185" : "width125"}
                          style={{ padding: "12px" }}
                          label={item.name}
                          value={item.id}
                          disableFocusRipple
                        ></Tab>
                      ))}
                    </TabList>
                  </Box>
                </Col>
              </Row>
            </Container>
            <TabPanel value={1} style={{padding : 0}}>
              <section className="press-release-sc" >
                <Container>
                  <Row>
                    <Col style={{padding: 0}}>
                      <MarketOutlookComponent />
                    </Col>
                  </Row>
                </Container>
              </section>
            </TabPanel>
            <TabPanel value={2}>
              <section className="blog-sc global-blog-sc">
                <Container>
                  <Row>
                    <Container>
                      <Col >
                        <BBB />
                      </Col>
                    </Container>
                  </Row>
                </Container>
              </section>
            </TabPanel>
            <TabPanel value={3}>
              <section className="press-release-sc">
                <Container>
                  <Row>
                    <Container>
                      <Col style={{padding: 0}}>
                        <OtherVideos/>
                      </Col>
                    </Container>
                  </Row>
                </Container>
              </section>
            </TabPanel>
          </TabContext>
        </Box>
      </section>
    </>
  );
}
